/* tslint:disable */
/* eslint-disable */
/**
 * KNMI exons API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AccessToken } from '../types';
// @ts-ignore
import type { AuthorizationCodeBody } from '../types';
// @ts-ignore
import type { OAuthURL } from '../types';
// @ts-ignore
import type { ValidationError } from '../types';
/**
 * AuthorizationApi - axios parameter creator
 * @export
 */
export const AuthorizationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns AWS Cognito OAuth sign-in URL for current Extranet.
         * @summary Get sign-in URL for current Extranet
         * @param {string} [callbackUrl] 
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCognitoSigninUrl: async (callbackUrl?: string, state?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/cognito/signin_url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (callbackUrl !== undefined) {
                localVarQueryParameter['callback_url'] = callbackUrl;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns AWS Cognito OAuth sign-out URL for current Extranet.
         * @summary Get sign-in URL for current Extranet
         * @param {string} [callbackUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCognitoSignoutUrl: async (callbackUrl?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/cognito/signout_url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (callbackUrl !== undefined) {
                localVarQueryParameter['callback_url'] = callbackUrl;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns access token based on authorization code.
         * @summary Authorize user for current Extranet with authorization code
         * @param {AuthorizationCodeBody} [authorizationCodeBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithAuthorizationCode: async (authorizationCodeBody?: AuthorizationCodeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/cognito/authorize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authorizationCodeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthorizationApi - functional programming interface
 * @export
 */
export const AuthorizationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthorizationApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns AWS Cognito OAuth sign-in URL for current Extranet.
         * @summary Get sign-in URL for current Extranet
         * @param {string} [callbackUrl] 
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCognitoSigninUrl(callbackUrl?: string, state?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OAuthURL>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCognitoSigninUrl(callbackUrl, state, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthorizationApi.getCognitoSigninUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns AWS Cognito OAuth sign-out URL for current Extranet.
         * @summary Get sign-in URL for current Extranet
         * @param {string} [callbackUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCognitoSignoutUrl(callbackUrl?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OAuthURL>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCognitoSignoutUrl(callbackUrl, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthorizationApi.getCognitoSignoutUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns access token based on authorization code.
         * @summary Authorize user for current Extranet with authorization code
         * @param {AuthorizationCodeBody} [authorizationCodeBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginWithAuthorizationCode(authorizationCodeBody?: AuthorizationCodeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginWithAuthorizationCode(authorizationCodeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthorizationApi.loginWithAuthorizationCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthorizationApi - factory interface
 * @export
 */
export const AuthorizationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthorizationApiFp(configuration)
    return {
        /**
         * Returns AWS Cognito OAuth sign-in URL for current Extranet.
         * @summary Get sign-in URL for current Extranet
         * @param {string} [callbackUrl] 
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCognitoSigninUrl(callbackUrl?: string, state?: string, options?: RawAxiosRequestConfig): AxiosPromise<OAuthURL> {
            return localVarFp.getCognitoSigninUrl(callbackUrl, state, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns AWS Cognito OAuth sign-out URL for current Extranet.
         * @summary Get sign-in URL for current Extranet
         * @param {string} [callbackUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCognitoSignoutUrl(callbackUrl?: string, options?: RawAxiosRequestConfig): AxiosPromise<OAuthURL> {
            return localVarFp.getCognitoSignoutUrl(callbackUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns access token based on authorization code.
         * @summary Authorize user for current Extranet with authorization code
         * @param {AuthorizationCodeBody} [authorizationCodeBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithAuthorizationCode(authorizationCodeBody?: AuthorizationCodeBody, options?: RawAxiosRequestConfig): AxiosPromise<AccessToken> {
            return localVarFp.loginWithAuthorizationCode(authorizationCodeBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthorizationApi - object-oriented interface
 * @export
 * @class AuthorizationApi
 * @extends {BaseAPI}
 */
export class AuthorizationApi extends BaseAPI {
    /**
     * Returns AWS Cognito OAuth sign-in URL for current Extranet.
     * @summary Get sign-in URL for current Extranet
     * @param {string} [callbackUrl] 
     * @param {string} [state] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public getCognitoSigninUrl(callbackUrl?: string, state?: string, options?: RawAxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).getCognitoSigninUrl(callbackUrl, state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns AWS Cognito OAuth sign-out URL for current Extranet.
     * @summary Get sign-in URL for current Extranet
     * @param {string} [callbackUrl] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public getCognitoSignoutUrl(callbackUrl?: string, options?: RawAxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).getCognitoSignoutUrl(callbackUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns access token based on authorization code.
     * @summary Authorize user for current Extranet with authorization code
     * @param {AuthorizationCodeBody} [authorizationCodeBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public loginWithAuthorizationCode(authorizationCodeBody?: AuthorizationCodeBody, options?: RawAxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).loginWithAuthorizationCode(authorizationCodeBody, options).then((request) => request(this.axios, this.basePath));
    }
}

